import { render, staticRenderFns } from "./RoundTable.vue?vue&type=template&id=4b9758be"
import script from "./RoundTable.vue?vue&type=script&lang=js"
export * from "./RoundTable.vue?vue&type=script&lang=js"
import style0 from "./RoundTable.vue?vue&type=style&index=0&id=4b9758be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports